export default __webpack_public_path__ + "static/media/Nicolas.4ca43b6c.png";